import { NewLP } from './NewLP';

export default NewLP;
